import dayjs from "dayjs";
import { User, Recipient, ContentType } from "@/types";

export const formatUserName = (user?: User | Recipient | null) => {
  if (!user) return "Deleted user";
  if (user.firstName && user.lastName) {
    return `${user.firstName} ${user.lastName}`;
  } else if (user.firstName) {
    return user.firstName;
  } else if (user.lastName) {
    return user.lastName;
  } else if (user.email) {
    return user.email;
  } else {
    return user.externalId;
  }
}

export const formatUserNameWithEmail = (user?: User | Recipient | null) => {
  if (!user) return "Deleted user";
  if (user.firstName && user.lastName) {
    return `${user.firstName} ${user.lastName} (${user.email})`;
  } else if (user.firstName) {
    return `${user.firstName} (${user.email})`;
  } else if (user.lastName) {
    return `${user.lastName} (${user.email})`;
  } else if (user.email) {
    return user.email;
  } else {
    return user.externalId;
  }
}

export const formatDate = (date?: Date | string) =>
  date ? dayjs(date).format('DD MMM YYYY') : "-";

export const formatDatetime = (date?: Date | string) =>
  date ? dayjs(date).format('DD MMM YYYY, HH:mm') : "-";

export function wrapPromise<T>(promise: Promise<T>) {
  let status: "pending" | "success" | "error" = "pending";
  let result: T;
  const suspender = promise.then(
    (r) => {
      status = "success";
      result = r;
    },
    (e) => {
      status = "error";
      result = e;
    }
  );
  return {
    read() {
      if (status === "pending") {
        throw suspender;
      } else if (status === "error") {
        throw result;
      } else {
        return result;
      }
    }
  };
}

export const formatContentType = (contentType: ContentType) => {
  switch (contentType) {
    case ContentType.Html:
      return 'HTML'
    case ContentType.Markdown:
      return 'Markdown'
    case ContentType.Plaintext:
      return 'Plaintext'
    case ContentType.Json:
      return 'JSON'
    case ContentType.Visual:
      return 'Visual'
  }
};
